<template>
    <div class="cart-container" v-if="getCart.length" @click="$router.push('/cart')">
        <div class="cart">
            <fa  :icon="['fas', 'shopping-cart']"/>
            <span v-text="getCart.length"></span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EventView',
  components: {},
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['getCart'])
  }
}
</script>
<style lang="less">
.cart-container {
    transform: scale(.7);
    filter: drop-shadow(2px 4px 6px gray);
    position: fixed;
    bottom: 55px;
    right: 20px;
    .cart {
        position: relative;
        background: var(--primaryColor);
        color: white;
        display: flex;
        height: 70px;
        width: 65px;
        border-radius: 100%;
        border-bottom-right-radius: 100%;
        border-bottom-left-radius: 100%;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        span {
            width: 35px;
            height: 35px;
            background: red;
            border-radius: 100%;
            position: absolute;
            display: flex;
            top: -10px;
            right: 0;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: center;
            align-items: center;
        }
        svg {
            padding-top: 15px;
            height: 25px;
        }
        &:after {
            content: '';
            width: 0;
            height: 0;
            position: absolute;
            border-left: 28px solid transparent;
            border-right: 25px solid transparent;
            border-top: 45px solid var(--primaryColor);
            bottom: -30px;
        }
    }
}
</style>
